<script lang="ts">
	import {
		ActionsContainer,
		Label,
		LabelListV2,
		type LabelListV2PropsTypes,
	} from '@Shelly/shelly-design-system';
	import { type DotsPropsTypes } from '@Shelly/shelly-design-system';
	import { sidePanelStateCombined } from 'src/stores/ui/sidepanel-public';
	import { beforeUpdate } from 'svelte';

	export let event;
	export let useV2Components = false;
	export let labelProps: Partial<LabelListV2PropsTypes> = {};

	let color: DotsPropsTypes['color'][] = ['default', 'default'];

	const isVertical = $sidePanelStateCombined?.open;
	const size = isVertical ? 's' : 'xs'; //using xs because in device in list it breaks the layout

	let time = null;

	beforeUpdate(() => {
		//Adding color to dots for each event to show last event is less than 10 seconds
		time = Math.abs(Number((Date.now() / 1000).toFixed(0)));
		event?.forEach((e, i) => {
			const difference = Math.abs(time - Number((e.last_ev_ts / 1000).toFixed(0)));
			if (difference < 10) {
				color[i] = 'primary';
			} else {
				color[i] = 'default';
			}
		});
	});
</script>

{#if useV2Components}
	<LabelListV2
		a11yProps={{ isInteractive: false }}
		{size}
		{isVertical}
		{...labelProps}
		labelList={[
			{
				icon: 'fal fa-hand-back-point-up',
				dotsType: 'one',
				dotsColor: color[0],
			},
			{
				icon: 'fal fa-hand-back-point-up',
				dotsType: 'one',
				dotsColor: color[1],
			},
		]}
	/>
{:else}
	<ActionsContainer type="separator">
		<Label
			slot="first"
			icon="fas fa-hand-back-point-up"
			class="mr-s"
			dotsType={'one'}
			bind:dotsColor={color[0]}
			isVertical
			{size}
		/>
		<!-- size s and isVertical for vertical label. Other option is ot remove them for horizontal alignment. Also the icon can be fa-hand-back-point-right and is possible to be a fal for a icon with border only  -->
		<Label
			slot="second"
			icon="fas fa-hand-back-point-up"
			class="mr-s"
			dotsType={'one'}
			bind:dotsColor={color[1]}
			isVertical
			{size}
		/>
	</ActionsContainer>
{/if}
